export enum ErrorCode {
  Default = -1,
  NotActivated = 555,
}
